.overlay {
    position: fixed;
    inset: 0;
    background: var(--transparent-40);
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    position: relative;
    box-shadow: var(--box-shadow-3);

    --margin: var(--spacer-16);

    margin: var(--margin);
    width: min(720px, calc(100vw - 2 * var(--margin)));
    max-height: calc(100vh - 2 * var(--margin));
    background: var(--white);
    padding: var(--spacer-margin);
    overflow-y: auto;
}

.dialog {
    &:focus {
        outline: none;
    }

    &:focus-visible {
        box-shadow: var(--box-shadow-1);
    }

    fieldset {
        border: none;
        margin: 0;
        padding: 0;
    }
}

.fieldsWrapper {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-24);
    width: 100%;
}

.close {
    composes: base from "../Clickables/index.module.scss";
    position: absolute;
    right: var(--spacer-16);
    top: var(--spacer-16);

    svg {
        width: 24px;
        height: 24px;
    }
}
